import { useState, useEffect } from "react";
import RightTimeApi from "@/API";
import { FaPlusSquare } from "react-icons/fa";
import { toast } from "react-toastify";
import { RiSave3Fill } from "react-icons/ri";
import { ImCancelCircle } from "react-icons/im";
import { CiEdit } from "react-icons/ci";
import { AiOutlinePlus } from "react-icons/ai";
import Enums from "@/enums";
import ContentEditModal from "@modals/ContentEditModal";

export default function CompanyContentTab(props: any) {
  if (!props || !props.tabData) {
    console.error('CompanyContentTab: props or props.tabData is undefined');
    return null;
  }
  
  const { company, updateSpinner, activeTab, adminPerms } = props.tabData;

  const [contentData, updateContentData] = useState<any>(null);
  const [sortedContents, updateSortedContents] = useState<any[]>([]);
  const [isContentEditModalOpen, setIsContentEditModalOpen] = useState(false);
  const [modalSelectedRow, setModalSelectedRow] = useState(null);

  useEffect(() => {
    if (isOnThisTab()) {
      getContentDataAsync();
    }
  }, [activeTab]);

  function isOnThisTab() {
    return props && activeTab && activeTab === "content";
  }

  async function getContentDataAsync() {
    if (isOnThisTab()) {
      if (company.id) {
        updateSpinner(true);
        const resp = await RightTimeApi.getAsync(`/Company/${company.id}/Content`);
        updateSpinner(false);
        if (resp && resp.ok && resp.jsonData) {
          updateContentData(resp.jsonData);
          const sortedData = resp.jsonData.contents.sort((a, b) => a.contentType - b.contentType);
          updateSortedContents(sortedData);
        }
      }
    }
  }

  async function onAddContentAsync() {
    // Open modal with blank fields for new content
    setModalSelectedRow({
      id: 0,
      contentTypeId: '',
      name: '',
      companyId: company.id, // Set companyId for new record
      languages: []
    });
    setIsContentEditModalOpen(true);
  }

  
  async function handleContentEditModalCloseAsync() {
    setIsContentEditModalOpen(false);
    setModalSelectedRow(null);
    await getContentDataAsync();
  }

  if (isOnThisTab() && contentData && contentData.contents) {
    return (
      <>
        <div className="tableWrapper dimensionTable">
          <table>
            <caption>
              <span className="title">Content</span>
              <span
                className="actionIcon plusIcon captionRight contentAddAction"
                onClick={onAddContentAsync}
                title="Add Content"
              >
                <FaPlusSquare />
              </span>
            </caption>
            <thead>
              <tr>
                <th>Id</th>
                <th>Type</th>
                <th>Name</th>
                <th>Languages</th>
              </tr>
            </thead>
            <tbody>
              {sortedContents && sortedContents.length > 0
                ? sortedContents.map((content) => {
                    const langAbbrList = (content.languages && content.languages.length > 0)
                      ? content.languages
                          .map((l) => contentData.languages.find((lang) => lang.id === l.languageId)?.abbrev || "")
                          .filter(Boolean)
                          .join(", ")
                      : "";
                    return (
                      <tr
                        key={content.id}
                        onClick={() => {
                          setModalSelectedRow(content);
                          setIsContentEditModalOpen(true);
                        }}
                        className="clickableRow"
                      >
                        <td>{content.id}</td>
                        <td>{content.contentTypeName}</td>
                        <td>{content.name}</td>
                        <td
                          className="center clickable-cell"
                          title={langAbbrList ? `Edit content for: ${langAbbrList}` : "Add content"}
                        >
                          {langAbbrList
                            ? langAbbrList
                            : <AiOutlinePlus className="actionIcon plusIcon" />}
                        </td>
                      </tr>
                    );
                  })
                : null}
            </tbody>
          </table>
        </div>
        <ContentEditModal
          isOpen={isContentEditModalOpen}
          onClose={handleContentEditModalCloseAsync}
          companyId={Number(company.id) || 0}
          companyContentId={modalSelectedRow?.id ?? 0}
        />
      </>
    );
  } else {
    return null;
  }
}
